class StickyProductBar {
  constructor() {
    this.stickyBar = null;
    this.mainProductForm = null;
    this.closeButtonMobile = null;
    this.isVisible = false;
    this.scrollThreshold = 300; // Show bar after scrolling 300px
    this.lastScrollY = 0;
    this.isScrollingDown = false;

    this.variantsContainer = null;
    this.stickyVariantContainer = null;
    
    this.scrollHandlerAttached = false;
    this.variantChangeUnsubscriber = null;
    this.mutationObserver = null;

    this.stickyProductBarCloseButtonContainer = null;
    this.stickyProductBarCloseButton = null;
    
    this.init();
  }

  init() {
    console.log("init sticky-product-bar");
    
    // Query les éléments du DOM
    this.stickyBarContainer = document.querySelector('[data-sticky-product-bar]');
    this.stickyBar = document.querySelector('.sticky-product-bar');
    this.stickyVariants = document.querySelectorAll('[data-sticky-product-bar-variant]');
    this.mainProductForm = document.querySelector('product-form[data-section-id]');
    this.stickyProductBarCloseButtonContainer = document.querySelector("[data-sticky-product-bar-close-container]");
    this.stickyProductBarCloseButton = document.querySelector("[data-sticky-product-bar-close]");
    
    if (!this.stickyBar || !this.mainProductForm) {
      console.log("Sticky bar ou product form non trouvé, abandon de l'init");
      return;
    }
    
    this.setupVariantClickListeners();
    this.setupScrollListener();
    this.setupMutationObserver();
    this.cloneVariantsPicker();
    this.closeMobileVariantsPicker();
    this.initMetafieldSelector();
  }

  destroy() {
    // Arrêter l'observation des mutations
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
      this.mutationObserver = null;
    }
  }

  handleCloseButtonClick() {
    console.log("handleCloseButtonClick");
    this.stickyProductBarCloseButtonContainer.classList.add('hide');
    var variantsPickerMobile = document.querySelector(".sticky-product-bar__form-items--mobile");
    var variantsPickerDesktop = document.querySelector(".sticky-product-bar__form-items--desktop");
    variantsPickerMobile.classList.remove("active");
    variantsPickerDesktop.classList.remove("inactive");

    const fullwidthSelector = document.querySelector('.sticky-product-bar__metafield-selector--fullwidth');
    if (fullwidthSelector) fullwidthSelector.classList.remove('active');
  }

  setupVariantClickListeners() {
    this.stickyVariants.forEach(variant => {
      variant.addEventListener('click', () => this.handleVariantClick(variant));
    });
  }

  closeMobileVariantsPicker() {
    this.stickyProductBarCloseButton.addEventListener('click', this.handleCloseButtonClick.bind(this));
  }

  cloneVariantsPicker() {
    var copyContainer = document.querySelector("[data-sticky-fieldset-copy]");
    var variantsPicker = document.querySelector("variants-picker");
    
    const copie = variantsPicker.cloneNode(true);

    copyContainer.appendChild(copie);
  }

  handleVariantClick(variant) {
    const windowWidth = window.innerWidth;
    if (windowWidth < 1024) {
      var variantsPickerMobile = document.querySelector(".sticky-product-bar__form-items--mobile");
      var variantsPickerDesktop = document.querySelector(".sticky-product-bar__form-items--desktop");
      var stickyProductBarCloseButtonContainer = document.querySelector("[data-sticky-product-bar-close-container]");

      variantsPickerMobile.classList.add("active");
      variantsPickerDesktop.classList.add("inactive");
      stickyProductBarCloseButtonContainer.classList.remove("hide");

      const fullwidthSelector = document.querySelector('.sticky-product-bar__metafield-selector--fullwidth');
      if (fullwidthSelector) fullwidthSelector.classList.add('active');
    } else {
      var variantId = variant.getAttribute('data-sticky-product-bar-variant');
      document.querySelector(`variants-picker input[type="radio"][value="${variantId}"]`).click();
      this.updateActiveVariant(variantId);
    }
  }

  updateActiveVariant(variantId) {
    // Remove active class from all variants
    this.stickyVariants.forEach(variantEl => {
      variantEl.classList.remove('active');
    });

    // Add active class to the selected variant
    const activeVariant = document.querySelector(`[data-sticky-product-bar-variant="${variantId}"]`);
    if (activeVariant) {
      activeVariant.classList.add('active');
    }
  }

  setupMutationObserver() {
    // Observer les changements dans la sticky bar
    this.mutationObserver = new MutationObserver((mutations) => {
      let shouldReinit = false;
      
      mutations.forEach((mutation) => {
        // Vérifier si des éléments avec data-sticky-product-bar-variant ont été ajoutés/modifiés
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              // Vérifier si le node ajouté ou ses enfants contiennent des variantes
              if ((node.hasAttribute && node.hasAttribute('data-sticky-product-bar-variant')) || 
                  (node.querySelector && node.querySelector('[data-sticky-product-bar-variant]'))) {
                shouldReinit = true;
              }
            }
          });
        }
        
        // Vérifier si des attributs data-sticky-product-bar-variant ont été modifiés
        if (mutation.type === 'attributes' && 
            mutation.attributeName === 'data-sticky-product-bar-variant') {
          shouldReinit = true;
        }
      });
      
      if (shouldReinit) {
        console.log("Changement détecté dans les variantes de la sticky bar, réinitialisation...");

        // Re-query les variantes et ré-attacher les listeners
        this.stickyBarContainer = document.querySelector('[data-sticky-product-bar]');
        this.stickyBar = document.querySelector('.sticky-product-bar');
        this.stickyVariants = document.querySelectorAll('[data-sticky-product-bar-variant]');
        this.stickyProductBarCloseButtonContainer = document.querySelector("[data-sticky-product-bar-close-container]");
        this.stickyProductBarCloseButton = document.querySelector("[data-sticky-product-bar-close]");

        this.setupVariantClickListeners();
        this.closeMobileVariantsPicker();

        // Restaurer la visibilité si nécessaire
        if (this.isVisible && this.stickyBar) {
          this.stickyBar.classList.add('sticky-product-bar--visible');
        }

        this.cloneVariantsPicker();
        this.initMetafieldSelector();
      }
    });
    
    // Observer la sticky bar et tous ses descendants
    this.mutationObserver.observe(this.stickyBar, {
      childList: true,       // Observer l'ajout/suppression d'enfants
      subtree: true,         // Observer tous les descendants
      attributes: true,      // Observer les changements d'attributs
      attributeFilter: ['data-sticky-product-bar-variant', 'class'] // Filtrer les attributs à observer
    });
    
    console.log("MutationObserver configuré pour la sticky bar");
  }

  setupScrollListener() {
    let ticking = false;
    
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
  }

  handleScroll() {
    const currentScrollY = window.scrollY;
    const viewportHeight = window.innerHeight;
    
    // Show bar when scrolled past 100vh (viewport height)
    if (currentScrollY > viewportHeight && !this.isVisible) {
      this.showBar();
    }
    // Hide bar only when at the very top (less than 100vh)
    else if (currentScrollY <= viewportHeight && this.isVisible) {
      this.hideBar();
    }
    
    this.lastScrollY = currentScrollY;
  }

  showBar() {
    if (this.isVisible) return;
    
    this.stickyBar.classList.add('sticky-product-bar--visible');
    document.body.classList.add('sticky-product-bar-active');
    this.isVisible = true;
  }

  hideBar() {
    if (!this.isVisible) return;

    this.stickyBar.classList.remove('sticky-product-bar--visible');
    document.body.classList.remove('sticky-product-bar-active');
    this.isVisible = false;
  }

  initMetafieldSelector() {
    // Annuler les anciens écouteurs avant d'en attacher de nouveaux
    if (this._metafieldAbortController) {
      this._metafieldAbortController.abort();
    }
    this._metafieldAbortController = new AbortController();
    const signal = this._metafieldAbortController.signal;

    const selectors = document.querySelectorAll('.sticky-product-bar__metafield-selector');

    if (!selectors.length) return;

    selectors.forEach(selector => {
      const trigger = selector.querySelector('.sticky-product-bar__metafield-trigger');
      const dropdown = selector.querySelector('.sticky-product-bar__metafield-dropdown');

      if (!trigger || !dropdown) return;

      trigger.addEventListener('click', (e) => {
        e.stopPropagation();

        // Fermer les autres sélecteurs
        selectors.forEach(other => {
          if (other !== selector) {
            other.classList.remove('open');
            other.querySelector('.sticky-product-bar__metafield-trigger')?.setAttribute('aria-expanded', 'false');
          }
        });

        const isOpen = selector.classList.toggle('open');
        trigger.setAttribute('aria-expanded', isOpen);

        if (isOpen) {
          const rect = trigger.getBoundingClientRect();
          dropdown.style.bottom = (window.innerHeight - rect.top + 8) + 'px';
          dropdown.style.left = rect.left + 'px';
          dropdown.style.minWidth = rect.width + 'px';
        }
      }, { signal });
    });

    document.addEventListener('click', () => {
      selectors.forEach(selector => {
        selector.classList.remove('open');
        selector.querySelector('.sticky-product-bar__metafield-trigger')?.setAttribute('aria-expanded', 'false');
      });
    }, { signal });
  }

}

document.addEventListener('DOMContentLoaded', () => {
    if (!window.stickyProductBarInstance) {
      window.stickyProductBarInstance = new StickyProductBar();
    }
});